import { Children, cloneElement, isValidElement, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectVar } from "../../store/conf/confSlice.js";

function Button({
  onClick,
  children,
  isActive = false,
  type,
  disabled = false,
  label,
}) {
  // Colore pulsante da configurazione (Redux conf)
  const confButtonColor = useSelector(selectVar("_BKG_BUTTONCOLOR", null));

  // Util: scurisce un colore HEX (#rgb o #rrggbb) di una percentuale 0..1
  const darkenColor = (hex, amount = 0.12) => {
    if (!hex || typeof hex !== "string") return hex;
    let h = hex.trim();
    if (h.startsWith("rgba") || h.startsWith("rgb")) return hex; // non gestiamo RGB qui
    if (!h.startsWith("#")) return hex;
    h = h.slice(1);
    if (h.length === 3) {
      h = h.split("").map((c) => c + c).join("");
    }
    if (h.length !== 6) return hex;
    const num = parseInt(h, 16);
    let r = (num >> 16) & 0xff;
    let g = (num >> 8) & 0xff;
    let b = num & 0xff;
    const darken = (v) => Math.max(0, Math.min(255, Math.round(v * (1 - amount))));
    r = darken(r);
    g = darken(g);
    b = darken(b);
    const toHex = (v) => v.toString(16).padStart(2, "0");
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  };

  const [isHover, setIsHover] = useState(false);

  const newProps = {
    className: "inline-block px-4 py-2 md:px-6 md:py-3 whitespace-nowrap",
  };

  const bgClass = confButtonColor
    ? ""
    : isActive
    ? "bg-button-gradient--active"
    : "bg-button-gradient";

  const hoverClass = confButtonColor
    ? "hover:opacity-90"
    : "hover:bg-none hover:bg-stone-50 hover:text-red-900";

  const styleOverride = confButtonColor
    ? {
        background: isHover ? darkenColor(confButtonColor) : confButtonColor,
        backgroundImage: "none",
        transition: "background-color 150ms ease, filter 150ms",
      }
    : undefined;

  return (
    <button
      className={`inline-block px-2 py-2 font-bold rounded-lg cursor-pointer text-white ${hoverClass} disabled:cursor-not-allowed uppercase text-[1.3rem] md:text-[1.6rem] ${bgClass} disabled:bg-none disabled:bg-stone-600 disabled:text-stone-50`}
      onClick={onClick}
      type={type}
      disabled={disabled}
      aria-label={label}
      onMouseEnter={() => confButtonColor && setIsHover(true)}
      onMouseLeave={() => confButtonColor && setIsHover(false)}
      style={styleOverride}
    >
      {Children.map(children, (child) =>
        isValidElement(child) ? cloneElement(child, newProps) : child
      )}
    </button>
  );
}

export default Button;
